import { render, staticRenderFns } from "./credit_limit.vue?vue&type=template&id=c510fd36&scoped=true&"
import script from "./credit_limit.vue?vue&type=script&lang=js&"
export * from "./credit_limit.vue?vue&type=script&lang=js&"
import style0 from "./credit_limit.vue?vue&type=style&index=0&id=c510fd36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c510fd36",
  null
  
)

export default component.exports